import { render, staticRenderFns } from "./middleForWxLogin.vue?vue&type=template&id=077e440c&"
import script from "./middleForWxLogin.vue?vue&type=script&lang=js&"
export * from "./middleForWxLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports